import { countries } from '@/data/countries'
import { provinces } from '@/data/province'
import { Country } from '@/types/country'
import { Province } from '@/types/province'
import { Box, FormLabel, Input, Select } from '@chakra-ui/react'
import { useEffect, useState } from 'react'

type Props = {
  province?: string
  country?: string
  required?: boolean
  setProvince: React.Dispatch<React.SetStateAction<string | undefined>>
  setCountry: React.Dispatch<React.SetStateAction<string | undefined>>
}

export const ProvinceAndCountrySelect = (props: Props) => {
  const [currentProvinces, setCurrentProvinces] = useState<Province[]>()

  useEffect(() => {
    if (typeof props.country === 'undefined') return
    const updatedProvince = provinces[props.country]?.list || null
    setCurrentProvinces(updatedProvince ?? [])
  }, [props.country])

  return (
    <>
      <Box>
        <FormLabel htmlFor='country'>Country</FormLabel>
        {countries && (
          <Select
            onChange={event => props.setCountry(event.target.value)}
            defaultValue={props.country}
            placeholder='Select a country'
            required={props.required}>
            {countries.map((country: Country) => (
              <option key={country.abbreviation} value={country.abbreviation}>
                {country.name}
              </option>
            ))}
          </Select>
        )}
      </Box>
      <Box>
        <FormLabel htmlFor='state'>
          {provinces[props.country || 'US']?.type || 'State'}
        </FormLabel>
        {currentProvinces && currentProvinces.length > 0 ? (
          <Select
            defaultValue={props.province}
            onChange={event => props.setProvince(event.target.value)}
            required={props.required}>
            <option value=''>
              Select a {provinces[props.country || 'US']?.type || 'State'}
            </option>
            {currentProvinces.map((province: Province) => (
              <option key={province.abbreviation} value={province.abbreviation}>
                {province.name}
              </option>
            ))}
          </Select>
        ) : (
          <Input
            id='state'
            type='state'
            value={props.province}
            onChange={event => props.setProvince(event.target.value)}
            placeholder='State or Province'
            required={props.required}
          />
        )}
      </Box>
    </>
  )
}
